export const socialsData = {
    github: 'https://github.com/muhammadmuzammal56',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/muzammal56/',
    instagram: 'https://www.instagram.com/me_muzammal?igsh=MXEyYmIzajI0eXBwZw==',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: 'https://medium.com/@sreerag.rajan5',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}